/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Rejection details
 * @export
 * @interface RejectTenantRelationshipRequest
 */
export interface RejectTenantRelationshipRequest {
    /**
     * ID of the relationship to reject
     * @type {string}
     * @memberof RejectTenantRelationshipRequest
     */
    relationshipId: string;
    /**
     * Reason for rejecting the relationship
     * @type {string}
     * @memberof RejectTenantRelationshipRequest
     */
    rejectionReason: string;
}

/**
 * Check if a given object implements the RejectTenantRelationshipRequest interface.
 */
export function instanceOfRejectTenantRelationshipRequest(value: object): value is RejectTenantRelationshipRequest {
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    if (!('rejectionReason' in value) || value['rejectionReason'] === undefined) return false;
    return true;
}

export function RejectTenantRelationshipRequestFromJSON(json: any): RejectTenantRelationshipRequest {
    return RejectTenantRelationshipRequestFromJSONTyped(json, false);
}

export function RejectTenantRelationshipRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectTenantRelationshipRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'],
        'rejectionReason': json['rejectionReason'],
    };
}

export function RejectTenantRelationshipRequestToJSON(json: any): RejectTenantRelationshipRequest {
    return RejectTenantRelationshipRequestToJSONTyped(json, false);
}

export function RejectTenantRelationshipRequestToJSONTyped(value?: RejectTenantRelationshipRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'rejectionReason': value['rejectionReason'],
    };
}

